<template>
 <div class="comment-form">
    <strong>{{title}}</strong>
    <div class="default-tag">
      <p @click="addText('Замена Исполнителя')">Замена Исполнителя</p>
      <p @click="addText('Срыв Перевозчику')">Срыв Перевозчику</p>
    </div>
    <textarea v-model="comment" name="comment" rows="5"></textarea>
    <my-shrunk-button
      class="send-form-btn"
      @click="sendStatus"
      :btnSettings="{shrunk:true,name:''}">Отправить
    </my-shrunk-button>          
  </div>
</template>

<script>
import { ref,computed } from 'vue'
import { createToaster } from "@meforma/vue-toaster";

export default {
  name: 'comment-form',
  props:['title'],
  setup(_,{emit}){
    const toaster = createToaster();

    const comment = ref('')
    const isTextareaEmpty = computed(() => comment.value.trim() === '')

    const addText = (val) => {
      comment.value = val
    }

    function sendStatus() {
      if (!isTextareaEmpty.value) {
        emit('updateComment', comment.value)
      }else{
        toaster.error("Заполните причину отмены");
      }
    }

    return{
      addText,
      comment,
      sendStatus
    }
  }
};
</script>

<style scoped>
.bg-denied{
  background-color: rgba(182,0,24,0.8);
}
.bg-success{
  background-color: rgba(145,218,85,1);
}
.comment-form{
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

}
.comment-form strong{
  margin-bottom: 5px;
}
.send-form-btn{
  margin-top: 10px;
}

textarea {
  width: 350px;
}

.default-tag{
  display: flex;
  margin-bottom: 10px;
  font-size: 12px;
  cursor: pointer;
}

.default-tag * {
  background-color: rgba(200,245,188,1);
  margin-left: 5px;
  border-radius: 15px;
  padding: 5px;
}
</style>